<template>
  <form @submit.prevent="save()" class="ui small form">
    <h3 class="ui header">Configurações de Emissão de Parcelas</h3>
    <div class="inline field">
      <label for="invoice-days-before-setting">
        Emitir parcela N dias antes do vencimento
      </label>
      <input
        type="text"
        name="invoice-days-before-setting"
        v-model="form.invoice_days_before"
      />
    </div>
    <h4 class="ui dividing header">Notificação para Nova Parcela</h4>
    <div class="inline field">
      <div class="ui checkbox">
        <input
          type="checkbox"
          id="invoice-send-new-invoice-notification-setting"
          v-model="form.invoice_send_new_invoice_notification"
        />
        <label for="invoice-send-new-invoice-notification-setting">
          Enviar notificação após criar uma nova parcela?
        </label>
      </div>
    </div>
    <div class="inline field">
      <div class="ui checkbox">
        <input
          type="checkbox"
          id="invoice-send-manual-invoice-notification-setting"
          v-model="form.invoice_send_manual_invoice_notification"
        />
        <label for="invoice-send-manual-invoice-notification-setting">
          Enviar notificação após criar uma nova parcela manualmente?
        </label>
      </div>
    </div>
    <div class="field">
      <label for="invoice-new-invoice-notification-title-setting">
        Título
      </label>
      <input
        type="text"
        v-model="form.invoice_new_invoice_notification_title"
        id="invoice-new-invoice-notification-title-setting"
      />
    </div>
    <div class="fields">
      <div class="twelve wide field">
        <label for="invoice-new-invoice-notification-body-setting">
          Mensagem
        </label>
        <textarea
          v-model="form.invoice_new_invoice_notification_body"
          id="invoice-new-invoice-notification-body-setting"
          rows="8"
          cols="80"
        >
        </textarea>
      </div>
      <div class="four wide field">
        <label for="">Opções</label>
        <div>[nome_do_titular]</div>
        <div>[codigo_do_contrato]</div>
        <div>[numero_da_parcela]</div>
        <div>[valor_da_parcela]</div>
      </div>
    </div>
  </form>
</template>
<script>
export default {
  data() {
    return {
      form: {
        invoice_days_before: null,
        invoice_send_manual_invoice_notification: null,
        invoice_send_new_invoice_notification: null,
        invoice_new_invoice_notification_title: null,
        invoice_new_invoice_notification_body: null,
      },
    };
  },

  methods: {
    setForm(settings) {
      const formKeys = Object.keys(this.form);
      settings.forEach(setting => {
        if (formKeys.includes(setting.key)) {
          this.form[setting.key] = setting.response;
        }
      });
    },

    getSettings() {
      return this.form;
    },
  },
};
</script>
